var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-skeleton"},[_c('header',[_c('div',{staticClass:"left"},[_vm._t("header-left")],2),_c('div',{staticClass:"right"},[_vm._t("header-right")],2)]),_c('section',[_vm._t("container"),_vm._t("default")],2),_c('footer',[_c('div',[_vm._t("footer-left")],2),_c('div',[_vm._t("footer-right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }